import { BellOutlined } from "@ant-design/icons";
import { Badge, Dropdown, Button, Empty, Avatar } from "antd";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import NotificationService from "../../services/NotificationService";
import styles from './NotificationsMenu.module.scss';
import { useUserContext } from "../../contexts/UserContext";
import { useNotificationContext } from "../../contexts/NotificationContext";
function NotificationItem({ icon, title, description, notification }) {
    const { currentUser } = useUserContext();
    const navigate = useNavigate();
    const { loadUnreadNotifications, loadUnreadNotificationsCount } = useNotificationContext();
    const handleReadNotificationAndRedirect = () => {
        NotificationService.getInstance()
            .markAsRead(currentUser.uid, notification.id)
            .then(() => {
                loadUnreadNotifications();
                loadUnreadNotificationsCount();
                navigate(notification.data.url); // Redirection vers l'URL de la notification
            })
            .catch((error) => {
                console.error("Error marking notification as read:", error);
            });
    };
    return (
        <div className={styles.notificationItem} onClick={handleReadNotificationAndRedirect}>
            <div className={styles.icon}>{icon}</div>
            <div className={styles.content}>
                <span className={styles.title}>{title}</span>
                <p className={styles.description}>{description}</p>
            </div>
        </div>
    );
}
NotificationItem.propTypes = {
    icon: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    notification: PropTypes.object.isRequired,
};
export default function NotificationsMenu() {
    const navigate = useNavigate();
    const { countUnreadNotifications, unReadNotifications } = useNotificationContext();
    

    const menuItems = unReadNotifications.length > 0 ? unReadNotifications
        .map((notification) => ({
            label: (
                <NotificationItem
                    icon={<Avatar src={notification.data.avatar} />}
                    title={notification.data.title}
                    description={notification.data.body}
                    notification={notification} // Passez l'objet notification complet
                />
            ),
            key: notification.id,
        })) : [{
            label: (
                <Empty description="Vous n'avez pas de notifications non lues" />
            ),
            key: 'empty',
        }];

    menuItems.push({
        // Adding the "See More" button
        label: (
            <div className={styles.seeMoreButton}>
                <Button size="small" type="link" className={styles.title} onClick={() => navigate('/notifications')}>
                    Voir plus
                </Button>
            </div>
        ),
        key: '4',
    });
    return (
        <Dropdown
            menu={{ items: menuItems }}
            trigger={['click']}
            placement="bottomRight"
        >
            <Badge count={countUnreadNotifications} size="small">
                <div className={styles.trigger}>
                    <BellOutlined />
                </div>
            </Badge>
        </Dropdown>
    );
}